module.exports = __webpack_public_path__ + "img/17870_S.e3911b23.png";